import React, { useRef, Fragment } from "react"
import posed from "react-pose"
import cx from "classnames"
import { useOvermind } from "../overmind"

export const Panel = () => {
  const { state, actions } = useOvermind()
  const PanelElement = posed.div({
    hidden: {
      x: `${state.menu.animation.firstPanel.hidden}vw`,
      transition: { ease: "linear", duration: 300 }
    },

    show: {
      x: `${state.menu.animation.firstPanel.show}vw`,
      transition: { ease: "linear", duration: 600 }
    },
    initialPose: "hidden"
  })

  return (
    <PanelElement
      key="firstPanel"
      initialPose="hidden"
      className="menuPanel1"
      pose={state.menu.isVisibleFirstPanel ? "show" : "hidden"}>
      <StaggerItems />
    </PanelElement>
  )
}

const MenuElementWrap = ({ item }) => {
  const { state, actions } = useOvermind()

  const _handleOpen = e => {
    actions.menu.setSecondPanelVisible({ id: item.id, itemid: item.id_md5 })
  }

  const classItem = cx("menuElement", { menuElementActive: item.id === state.menu.activeFirstElement || item.current })

  return (
    <div key={item.id_md5} className={classItem}>
      {item.items ? (
        <Fragment>
          <div href={item.link} data-id={item.id} data-itemid={item.id_md5} onClick={_handleOpen}>
            {item.text}
          </div>
          <svg className="svg-icon" width="24" height="24" aria-hidden="true">
            <use xlinkHref="#arrow-medium-right" />
          </svg>
        </Fragment>
      ) : (
        <a href={item.link}>{item.text}</a>
      )}
    </div>
  )
}

const StaggerItems = () => {
  const { state, actions } = useOvermind()
  const StaggerElement = posed.div({
    closed: {
      opacity: 1,
      delayChildren: 200,
      staggerChildren: 50,
      afterChildren: true
    },

    open: {
      opacity: 1,
      beforeChildren: true,
      delayChildren: 0,
      staggerChildren: 75
    }
  })
  const MenuElement = posed.li({
    closed: {
      y: state.menu.animation.firstPanel.stagger,
      opacity: state.menu.animation.firstPanel.staggerOpacity,
      transition: { duration: 400 }
    },
    open: { y: 0, opacity: 1, transition: { duration: 600 } }
  })

  const FormElement = posed.div({
    closed: {
      y: state.menu.animation.firstPanel.stagger,
      opacity: state.menu.animation.firstPanel.staggerOpacity,
      transition: { duration: 400 }
    },
    open: { y: 0, opacity: 1, transition: { duration: 600 } }
  })
  const SocialElements = posed.div({
    closed: { delayChildren: 600, staggerChildren: 50 },
    open: { delayChildren: 1000, staggerChildren: 50 },
    initialPose: "closed"
  })

  const SocialElement = posed.a({
    closed: {
      x: state.menu.animation.firstPanel.staggerSocial,
      opacity: state.menu.animation.firstPanel.staggerOpacity,
      transition: { duration: 400 }
    },
    open: { x: 0, opacity: 1, transition: { duration: 600 } }
  })

  return (
    <StaggerElement pose={state.menu.isVisibleFirstPanel ? "open" : "closed"} key="staggerPanel" initialPose="closed">
      <ul className="menuMain">
        {state.menu.data &&
          state.menu.data.map((item, index) => (
            <MenuElement key={item.id_md5}>
              <MenuElementWrap item={item} />
            </MenuElement>
          ))}
      </ul>
      <FormElement key="formElement">
        <form className="menuMobileSearch">
          {/* <input className="menuMobileSearchInput" type="search" placeholder="Поиск" required="" />
      <button className="menuMobileSearchButton">
        <svg className="svg-icon" width="20" height="20" aria-hidden="true">
          <use xlinkHref="#icon-search" />
        </svg>
      </button> */}
        </form>

        <div className="menuFooter">
          <SocialElements className="menuFooterNetworks" key="footerElement">
            {social.map((social, index) => {
              return (
                <SocialElement
                  key={"social" + index}
                  className="menuFooterNetworksElement"
                  href={social.link}
                  target="_blank">
                  <svg className="svg-icon" width="26" height="26" role="img" aria-label="twitter">
                    <use xlinkHref={`#${social.icon}`} />
                  </svg>
                </SocialElement>
              )
            })}
          </SocialElements>
        </div>
      </FormElement>
    </StaggerElement>
  )
}
